import React from 'react';
import Actions from "../modules/actions";
import { connect } from "react-redux";
import Webcam from "react-webcam";
import MyButton from "./MyButton";

const mapStateToProps = state => {
  return ({
    buildingId: state.currentBuildingId,
    facadeId: state.currentFacadeId,
  });
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  setImage: (buildingId, facadeId, imageSrc) => dispatch(Actions.setImage(buildingId, facadeId, imageSrc)),
});

const videoConstraints = {
  width: 1280,
  height: 720,
  facingMode: "user"
};

const MyWebcam = props => {
  const webcamRef = React.useRef(null);

  const capture = React.useCallback(
    () => {
      const imageSrc = webcamRef.current.getScreenshot();
      props.setImage(props.buildingId, props.facadeId, imageSrc);
      props.closeModal();
    },
    [webcamRef]
  );

  return (
    <div>
      <Webcam
        audio={false}
        ref={webcamRef}
        screenshotFormat="image/jpeg"
        width="100%"
        videoConstraints={videoConstraints}
      />
      <MyButton variant="contained" onClick={capture}>{props.Lang.webcam.capture_photo}</MyButton>
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyWebcam);


// WEBPACK FOOTER //
// ./src/pages/MyWebcam.js